var _path, _path2, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _path19, _path20, _circle, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse, _line, _line2, _line3, _path27, _path28, _path29, _g, _path30, _rect2, _path31, _polygon3, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _polygon4, _path39, _path40, _rect3, _rect4, _path41, _rect5, _polygon5, _path42, _path43, _path44, _path45, _polygon6, _polygon7, _polygon8, _polygon9, _g2, _path46, _path47, _path48, _path49, _path50, _ellipse2, _path51, _ellipse3, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _ellipse4, _path62, _ellipse5, _path63, _path64;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "acc7915b-2fa9-4b65-b87e-136b5c71e29d",
    "data-name": "fc64dd83-e3b3-437b-a4fc-7f82ea6d7acf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.44,646.81,539,647s-27.46-34.78-79-23c0,0-8.12-37.3-59.7-7.53,0,0-6.11-28.32-77.35-24.87l-44.54,22.9Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.79,591.58l75.72-85.43s27-27.81,33.76-20.35c0,0,8.82,19-6.11,39.35,0,0,47.49,25.1-33.24,49.53,0,0,52.81,27.35-26.18,49.3,0,0,60.78,8.8,61.46,22.83H70.2s-2.56-6.6,2.9-15.06c0,0-38.73-21.54-33.54-43.63,0,0,3.81-11.18,19.63-11.18,0,0-42.81-12-35.45-24.54,0,0,5.18-12.27,18.27-12.54,0,0-31.52-24.3-14.33-54.82a13.93,13.93,0,0,1,12.66-7.1c8,.32,19.84,4.42,27,23.47,0,0,15.29-15,28.74-7.82,0,0,20.32,9.86,7.69,60.26,0,0,17-22.1,29.66-12.49,0,0,6.59,3.3,16.47,29.66,0,0,27,6.5,36.85,13.86,0,0-19.84-30.06-17.59-59.52,0,0,5.86-56.11,36.93-50.22,0,0,15.58,4.82,14.07,42.86C220.16,518,260.84,515.45,250.79,591.58Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.79,591.58l75.72-85.43s27-27.81,33.76-20.35c0,0,8.82,19-6.11,39.35,0,0,47.49,25.1-33.24,49.53,0,0,52.81,27.35-26.18,49.3,0,0,60.78,8.8,61.46,22.83H70.2s-2.56-6.6,2.9-15.06c0,0-38.73-21.54-33.54-43.63,0,0,3.81-11.18,19.63-11.18,0,0-42.81-12-35.45-24.54,0,0,5.18-12.27,18.27-12.54,0,0-31.52-24.3-14.33-54.82a13.93,13.93,0,0,1,12.66-7.1c8,.32,19.84,4.42,27,23.47,0,0,15.29-15,28.74-7.82,0,0,20.32,9.86,7.69,60.26,0,0,17-22.1,29.66-12.49,0,0,6.59,3.3,16.47,29.66,0,0,27,6.5,36.85,13.86,0,0-19.84-30.06-17.59-59.52,0,0,5.86-56.11,36.93-50.22,0,0,15.58,4.82,14.07,42.86C220.16,518,260.84,515.45,250.79,591.58Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.65,642c-18,4.9-44.64-4.46-44.64-4.46,0-2.16,2.52-7.53,4-10.51a10,10,0,0,0,1.05-4.51l-.14-32.06c-1.08-21.18,1.63-63,1.63-63a252,252,0,0,0-2.16-65A65,65,0,0,1,250,464.93a121,121,0,0,0,20.31.82l.84,3c1.85,32.88-11,116.38-11,116.38l-6.91,39.73C252.56,635.51,274.65,642,274.65,642Z",
    fill: "#f9b499"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230,637.49s-3.66,3.66-2.62,11L293,650.65a.44.44,0,0,0,.46-.44.41.41,0,0,0-.14-.34c-2.14-1.89-8.29-6.48-18.69-7.92C274.65,642,262.43,647.25,230,637.49Z",
    fill: "#FD9300"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "293.01 653.05 227.39 650.78 227.39 648.5 293.02 650.65 293.01 653.05",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.87,637.49s-3.66,3.66-2.63,11l65.64,2.15a.44.44,0,0,0,.31-.78c-2.14-1.89-8.29-6.48-18.69-7.92C174.5,642,162.29,647.25,129.87,637.49Z",
    fill: "#FD9300"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.87 653.05 127.24 650.78 127.24 648.5 192.88 650.65 192.87 653.05",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.87,637.49s6.2-12.44,7-21.57l10-55.14s13.37-48.85,17.22-61.06c0,0,7.58-29.41,6.23-37.42,0,0,19.52,6.11,38.14,2.65,0,0-5.93,24-12.87,41.07l-31.24,84.32L154.45,619s-4.11,8.74,3.86,13.24L174.5,642S165.57,647.62,129.87,637.49Z",
    fill: "#f9b499"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.72,497.14q3.93,7.26,7.92,14.5t8,14.44c5.39,9.61,10.85,19.17,16.51,28.62s11.37,18.86,17.4,28.07c3,4.64,6.14,9.14,9.32,13.63l4.92,6.63,5.23,6.39c-7.54-8-13.94-17.09-20.16-26.19s-12-18.51-17.64-28-11-19.05-16.22-28.75S45.57,507,40.72,497.14Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.38,508.18c-.45,3.19-1,6.34-1.6,9.5s-1.24,6.3-1.89,9.44-1.37,6.27-2.13,9.38l-1.16,4.68c-.42,1.55-.8,3.1-1.26,4.65.22-1.6.5-3.18.75-4.76l.86-4.74c.57-3.16,1.23-6.3,1.89-9.44s1.36-6.27,2.13-9.38S74.5,511.27,75.38,508.18Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.17,560.76c3,.21,6.07.54,9.09.88s6,.75,9.05,1.16,6,.89,9,1.41l4.5.79c1.49.31,3,.57,4.48.91-1.53-.1-3-.26-4.56-.39L70.21,565c-3-.33-6-.75-9-1.17s-6-.88-9-1.41S46.15,561.41,43.17,560.76Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.76,565.91c-.62,2.19-1.35,4.35-2.09,6.49s-1.54,4.27-2.36,6.39-1.67,4.22-2.58,6.3l-1.38,3.12c-.49,1-.95,2.07-1.48,3.08.3-1.1.66-2.18,1-3.27l1.1-3.23c.73-2.15,1.54-4.27,2.35-6.39s1.68-4.22,2.59-6.3S104.73,567.94,105.76,565.91Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199,508.18l5.92,23.5q3,11.75,6,23.47c2,7.81,4.17,15.59,6.39,23.35l1.72,5.81,1.83,5.77c.58,1.93,1.3,3.81,2,5.73.31,1,.7,1.89,1.08,2.82l1.12,2.82a170.35,170.35,0,0,1-8.49-22.71c-2.39-7.72-4.54-15.52-6.64-23.32s-4-15.67-5.8-23.54S200.58,516.11,199,508.18Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.63,554.32c-.74,2.73-1.6,5.41-2.48,8.09s-1.8,5.34-2.75,8-1.93,5.29-3,7.9l-1.58,3.92c-.56,1.3-1.08,2.61-1.68,3.89.37-1.37.8-2.71,1.19-4.06l1.29-4c.87-2.68,1.81-5.33,2.75-8s1.94-5.28,3-7.9S230.47,556.9,231.63,554.32Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.14,545.83c4.18,1.1,8.24,2.51,12.28,4s8,3.1,11.92,5c-4.18-1.1-8.25-2.51-12.29-4A126.92,126.92,0,0,1,186.14,545.83Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M336.46,527c-6.65,7.6-13.39,15.11-20.15,22.62L296,572l-20.6,22.29-10.34,11.07-10.43,11,10-11.35,10.12-11.27,20.36-22.42,20.55-22.25C322.59,541.68,329.48,534.3,336.46,527Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M318.06,591.29c-4.29,1.28-8.61,2.44-12.94,3.58s-8.67,2.2-13,3.31-8.7,2.08-13.07,3.06l-6.55,1.45c-2.19.44-4.38.92-6.58,1.33,2.15-.64,4.31-1.23,6.46-1.84l6.48-1.74c4.32-1.14,8.67-2.2,13-3.3s8.7-2.09,13.07-3.07S313.66,592.14,318.06,591.29Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290.44,550.32c-.06,2.57-.23,5.13-.42,7.69s-.45,5.11-.71,7.66-.59,5.09-1,7.63l-.57,3.8c-.22,1.27-.42,2.54-.68,3.8,0-1.29.11-2.57.16-3.85l.27-3.84c.18-2.56.44-5.11.71-7.66s.58-5.09,1-7.63S289.94,552.84,290.44,550.32Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M351.19,540.7c-2.63.65-5.28,1.18-7.93,1.69s-5.31,1-8,1.4-5.33.83-8,1.16l-4,.5c-1.34.12-2.68.28-4,.38,1.31-.34,2.63-.6,3.95-.9l4-.79c2.65-.53,5.31-1,8-1.41s5.34-.82,8-1.15S348.49,540.91,351.19,540.7Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M584.24,646.81h259s-3.09-48.25-41.91-36.79c0,0-18-39.47-63.7-18.51,0,0,13.83-29.76,11.32-51.55,0,0-1-55.14-33.34-40.56a13.26,13.26,0,0,0-7.34,8.71,50,50,0,0,0-.81,21.79s-43.51,7.73-29.2,50a35.94,35.94,0,0,1,1.23,4.8L683,603.52l-50.51-58.68s-38-48.55-52-42.79c0,0-11.28,20.94,5.75,35,0,0-24.16,15.19-8.28,26.92l38.42,18.64s-50.16,21.86,23.24,44.18C639.65,626.76,585,637,584.24,646.81Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M584.24,646.81h259s-3.09-48.25-41.91-36.79c0,0-18-39.47-63.7-18.51,0,0,13.83-29.76,11.32-51.55,0,0-1-55.14-33.34-40.56a13.26,13.26,0,0,0-7.34,8.71,50,50,0,0,0-.81,21.79s-43.51,7.73-29.2,50a35.94,35.94,0,0,1,1.23,4.8L683,603.52l-50.51-58.68s-38-48.55-52-42.79c0,0-11.28,20.94,5.75,35,0,0-24.16,15.19-8.28,26.92l38.42,18.64s-50.16,21.86,23.24,44.18C639.65,626.76,585,637,584.24,646.81Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 642.34,
    y: 521.94,
    width: 1.07,
    height: 122.35,
    transform: "translate(-225.06 580.4) rotate(-42.03)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M304,462.61a111.72,111.72,0,0,1-32.9,6,119.86,119.86,0,0,1-20.31-.82,65.6,65.6,0,0,0-15.56-2.47,133.85,133.85,0,0,0-24.34,1.14,89.36,89.36,0,0,1-53.36-7.13,2.78,2.78,0,0,1-1.48-3.12l24.76-106.78,32-93.31,5.09,1.72c5.5-.79,7.15-3,7.15-3l12.64,3,27,82.72c10.32,18.7,35.95,96.19,42.36,115.8A5,5,0,0,1,304,462.61Z",
    fill: "#000000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M446.08,278.17s22.3-8.56,34.58,8.21c5.47,7.47,7,17.29,3,25.67-3.2,6.82-10.41,13.85-26.27,15.89Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.08,278.17s22.3-8.56,34.58,8.21c5.47,7.47,7,17.29,3,25.67-3.2,6.82-10.41,13.85-26.27,15.89Z",
    fill: "#fff",
    opacity: 0.59,
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 560.38,
    cy: 217.5,
    r: 25.92,
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 560.38,
    cy: 217.5,
    r: 25.92,
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M627.92,287.61s23.59,3.76,33.69-3.36l5.06-18.84s1-10.43,10.63-15.88a163.87,163.87,0,0,0-17.87,9.09l-18,9.06a6.16,6.16,0,0,1-5.52,0l-8-4Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M627.92,287.61s23.59,3.76,33.69-3.36l5.06-18.84s1-10.43,10.63-15.88a163.87,163.87,0,0,0-17.87,9.09l-18,9.06a6.16,6.16,0,0,1-5.52,0l-8-4Z",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M209.55,221v21.21a4.49,4.49,0,0,0,1.2,3.06l5.61,6a5.83,5.83,0,0,1,1.56,4v2.48s5-.65,7.16-3v-4.38a4.86,4.86,0,0,1,1-3l1.34-1.71v-12.2L214,219.7Z",
    fill: "#f9b499"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.46,233.51v8.38s-6.56.77-9.6-9Z",
    fill: "#f7a48b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M260.69,297.1l10,33.58.68,2.3a2.3,2.3,0,0,1-.39,2.1c-2.14,2.72-9.25,10-23.74,9.47a1.29,1.29,0,0,1-1.22-1L227.47,257.8a3.29,3.29,0,0,1-2.4-3v-4.4s-.58-1.79,2.4-4.72v-5.23s2.84.57,4.23,4.25c0,0,16.72,4.27,26.23,16.54,0,0,12.88,15.33,20.24,19H288l2.45,21.47S270.5,304.78,260.69,297.1Z",
    fill: "#FD9300"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M271,335.08c-2.14,2.72-9.25,10-23.74,9.47a1.29,1.29,0,0,1-1.22-1L227.47,257.8a3.29,3.29,0,0,1-2.4-3s4.3,3.21,8.31-2.46a7.17,7.17,0,0,1-4,5.67L247,329.48s5.95,16.84,23.69,1.2l.68,2.3A2.3,2.3,0,0,1,271,335.08Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271,335.08c-2.14,2.72-9.25,10-23.74,9.47a1.29,1.29,0,0,1-1.22-1L227.47,257.8a3.29,3.29,0,0,1-2.4-3s4.3,3.21,8.31-2.46a7.17,7.17,0,0,1-4,5.67L247,329.48s5.95,16.84,23.69,1.2l.68,2.3A2.3,2.3,0,0,1,271,335.08Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,248.94c2,3.33,3.89,6.79,5.65,10.28s3.38,7.06,4.87,10.69A105.72,105.72,0,0,1,256.87,281a59.39,59.39,0,0,1,2.28,11.51c-.21-.95-.42-1.91-.61-2.86s-.5-1.88-.75-2.82S257.26,285,257,284s-.56-1.86-.9-2.77c-1.24-3.69-2.65-7.32-4.12-10.93s-3.05-7.17-4.63-10.73c-.78-1.79-1.6-3.56-2.43-5.33S243.25,250.71,242.43,248.94Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M260.69,297.1s13-9.74,22.77,5.18C283.46,302.28,268.82,303.39,260.69,297.1Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.69,297.1s13-9.74,22.77,5.18C283.46,302.28,268.82,303.39,260.69,297.1Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.16,257.35q2.58,12.88,4.84,25.81t4.24,25.92c2.67,17.3,4.94,34.67,7,52.06s3.51,34.84,4.68,52.32l.71,13.11.18,3.28.11,3.28.22,6.56c.35,8.75.24,17.51.31,26.26-.24-8.75-.31-17.5-.84-26.24l-.29-6.55-.15-3.28-.21-3.27-.87-13.1c-1.33-17.44-2.88-34.87-4.92-52.25s-4.23-34.74-6.72-52.06q-1.87-13-4-25.95T220.16,257.35Z",
    opacity: 0.45,
    style: {
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.23,
    cy: 186.83,
    rx: 10.03,
    ry: 7.08,
    transform: "translate(-49.67 81.68) rotate(-19.31)",
    fill: "#000000"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 302.26,
    y1: 335.3,
    x2: 294.74,
    y2: 327.94,
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 305.94,
    y1: 332.7,
    x2: 298.5,
    y2: 324.93,
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 307.29,
    y1: 329.78,
    x2: 301.03,
    y2: 323.09,
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M428.89,285.59c13.34-10.39,23.94-8.3,31.2-3.6a26.55,26.55,0,0,1,11.7,24c-2,34.28-38.53,20.49-38.53,20.49l7,45.07L298.5,390l-15-141,45.38-5.33s-4.32,36.1,28.64,33.74c0,0,28-3.73,19.17-39.68L423,232.91Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.89,285.59c13.34-10.39,23.94-8.3,31.2-3.6a26.55,26.55,0,0,1,11.7,24c-2,34.28-38.53,20.49-38.53,20.49l7,45.07L298.5,390l-15-141,45.38-5.33s-4.32,36.1,28.64,33.74c0,0,28-3.73,19.17-39.68L423,232.91Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M423,232.91l15.64-1.26,5.65,46.71s-6.43.4-15.41,7.23Z",
    fill: "#FD9300"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M440.27,371.51l14.84-2.86-5.37-39.49s-9.25.22-16.48-2.72Z",
    fill: "#FD9300"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423,232.91l15.64-1.26,5.65,46.71s-6.43.4-15.41,7.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.27,371.51l14.84-2.86-5.37-39.49s-9.25.22-16.48-2.72Z",
    fill: "#fff"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M568.55,232.91h-.33a25.94,25.94,0,1,0-41.7,0H473.17v46.64s25.31-7.54,34.49,11.64a28.19,28.19,0,0,1,.44,23c-3.68,8.77-12.55,18.79-33.8,13.73v45.6h142V232.91Z",
    fill: "#FD9300"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 616.26,
    y: 232.91,
    width: 11.66,
    height: 140.62,
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 616.26,
    y: 232.91,
    width: 11.66,
    height: 140.62,
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M589.73,302V290.42h-8.47a29.35,29.35,0,0,0-3.79-8.07l6-5.55-7.81-8.5-6.44,5.92A29,29,0,0,0,558.93,270v-8.52H547.39V270a29.09,29.09,0,0,0-10.74,4.53l-4.7-5.11-8.5,7.81,5.13,5.59a28.85,28.85,0,0,0-4.26,10.9l-6.51-.23-.4,11.54,7.23.25a29.19,29.19,0,0,0,6.09,12.21l-5.62,5.17,7.82,8.5,6.94-6.39a28.86,28.86,0,0,0,9.93,3v8.05h11.55v-9a29.3,29.3,0,0,0,10.09-5.24l4.72,5.13,8.5-7.81-5.74-6.25A29,29,0,0,0,582.25,302Zm-35.51,14.65c-9.56,0-17.32-8.06-17.32-18s7.76-18,17.32-18,17.31,8.06,17.31,18-7.75,18-17.31,18Z",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.32 341.12 402.32 341.99 395.06 285.59 383.79 286.68 389.9 343.35 382.82 344.12 378.73 314.63 366.88 316.01 370.14 345.5 363.38 346.24 358.47 304.58 346.14 305.51 351.34 347.56 345.72 348.17 339.17 292.5 326.85 293.98 332.98 349.56 326.51 350.27 326.82 353.09 410.63 343.94 410.32 341.12",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.86,360.44A45.33,45.33,0,0,1,81,356.26c24.51,0,44.37,19.32,44.37,43.15S105.46,442.55,81,442.55s-44.38-19.31-44.38-43.14H82Z",
    fill: "#FD9300"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.79,352.59,75.61,396H23.54S15.86,361.62,51.79,352.59Z",
    fill: "#000000"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M679.63,248.81s-11,1.64-13.68,19.3c0,0-14,46.88-16.52,77.16a3,3,0,0,0,2.48,3.16c10.88,1.72,52.29,7.79,76.71,4.71a3.28,3.28,0,0,0,2.83-3.68l0-.17a157.45,157.45,0,0,1-2.3-24.42s4.63-66.65-8.41-71.07l-15.09-5h-26Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M694.18,306.51s27.5-2.69,35.74-7.9c0,0-.11-12.32-.62-17.88,0,0-6.36,10.95-28.14,21.64Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.61,284.25s-5.07-14.48-2.18-25.63c0,0,12.32-7.25,17.87-9.09,0,0-9.19,3.72-10.63,15.88Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M629.78,308.49s-2.45,1.73-4.36,0l-7.64-8.23a2.21,2.21,0,0,0-3.12-.14l0,0h0a2.22,2.22,0,0,0-.35,2.8l3.18,5-23.55-.16a1.38,1.38,0,0,0-1.39,1.37h0v.34a1.38,1.38,0,0,0,1.37,1.39H609.4a.78.78,0,0,1,.78.78h0a.78.78,0,0,1-.78.78H592.17a1.38,1.38,0,0,0-1.38,1.38h0a1.38,1.38,0,0,0,1.37,1.39h0l16.92-.36a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1l-15.19-.29a1.38,1.38,0,0,0-1.38,1.38h0v.52a1.38,1.38,0,0,0,1.38,1.38h15.44a.78.78,0,0,1,.78.78h0v.69a.78.78,0,0,1-.78.78h-11.8a1.39,1.39,0,0,0-1.39,1.39h0v.91a1.38,1.38,0,0,0,1.38,1.38h.07l35.49-1.65Z",
    fill: "#f9b499"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M676.64,626.09h-.16c-1.43-.17-7.41,3.56-7.41,3.56-3.88,3.34-6.88,1.58-6.88,1.58,0-7.75-7.75-7.22-7.75-7.22V614l20.91-4Z",
    fill: "#f9b499"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M681.93,647.24l-53.67,2a10,10,0,0,1-4.29-.78c-8.26-3.46-6-7.07-6-7.07L654.44,624s7.75-.53,7.75,7.22c0,0,3,1.76,6.88-1.58,0,0,6-3.73,7.41-3.56h.16C678.94,629.62,681.93,647.24,681.93,647.24Z",
    fill: "#FD9300"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M681.93,647.24h0a2.67,2.67,0,0,1-2.55,2.67l-52.44,2.36c-6.36-.39-11-7.4-11-7.4-2.47-4.3,2.07-3.45,2.07-3.45s-2.26,3.61,6,7.07a10,10,0,0,0,4.29.78Z",
    fill: "#000000"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "756.85 610.02 760.56 619.58 769.59 628.38 781.87 619.2 777.7 601.27 756.85 610.02",
    fill: "#f9b499"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M792,635.32c-10.18,2.09-33.1,15.54-33.1,15.54-11.65,5.51-26.61-.39-29.07-1.43a1.19,1.19,0,0,1-.63-.62c-.75-1.78,2-3.54,2.33-3.73h0l28.13-24.75a4.9,4.9,0,0,1,2.45-1.16c4.94-.75,6.41,4.38,6.41,4.38a1.84,1.84,0,0,0,2.42,1.81,4.76,4.76,0,0,0,3-1.78c4.51-5.62,6.72-6.3,6.72-6.3,2.82-4.4,9.55,10.34,11.9,15.85.09.23.18.43.27.62a1.17,1.17,0,0,1-.66,1.52Z",
    fill: "#FD9300"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M796,635.32a2.46,2.46,0,0,1-1.85,2.64c-2.18.6-5.91,1.84-5.91,1.84-7.35,2-27.17,13.38-27.17,13.38-16,6.32-31.26-1.57-31.26-1.57-6.53-3.55,1.25-6.36,1.78-6.53-.31.19-3.08,1.95-2.33,3.73a1.19,1.19,0,0,0,.63.62c2.46,1,17.42,6.94,29.07,1.43,0,0,23-13.52,33.16-15.55A1.14,1.14,0,0,0,793,634a2.25,2.25,0,0,0-.08-.24c-.09-.2-.18-.4-.27-.63l.35-.06C795.13,633.39,795.84,634.36,796,635.32Z",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 638.99,
    y: 579.94,
    width: 1.07,
    height: 44.97,
    transform: "translate(-101.54 1074.37) rotate(-75.78)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 602.45,
    y: 539.42,
    width: 1.07,
    height: 29.42,
    transform: "matrix(0.07, -1, 1, 0.07, 7.65, 1116.47)",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M702.29,608.07l-1-.36c.2-.55,19.36-55.17,23-73.78l1.06.2C721.67,552.82,702.48,607.52,702.29,608.07Z",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 701.27,
    y: 564.66,
    width: 1.07,
    height: 28.1,
    transform: "translate(-171.8 325.25) rotate(-23.33)",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "716.37 565.38 715.92 564.41 733.54 556.32 733.99 557.3 716.37 565.38",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M425.51,150.19a11.57,11.57,0,0,1,3.72,2.67,17.88,17.88,0,0,1,4.68,9l2.49,12.22,28.14-4.84-1.81-14.53s-.92-5.74,3.17-8.77c0,0,17.72-15.16,9.41-36a35.6,35.6,0,0,0-24.57-21.37c-9-2.19-21.63-1.58-33,9.61,0,0-14.73,13.5-7.08,35.09C410.69,133.24,414,145.34,425.51,150.19Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.51,150.19a11.57,11.57,0,0,1,3.72,2.67,17.88,17.88,0,0,1,4.68,9l2.49,12.22,28.14-4.84-1.81-14.53s-.92-5.74,3.17-8.77c0,0,17.72-15.16,9.41-36a35.6,35.6,0,0,0-24.57-21.37c-9-2.19-21.63-1.58-33,9.61,0,0-14.73,13.5-7.08,35.09C410.69,133.24,414,145.34,425.51,150.19Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M434,143.79h-.13a8.08,8.08,0,0,1-5.78-4.33c-2.16-4.67.86-10.89,1-11.16,1.3-2.14,2.69-3.09,4.14-2.86,4.68.75,7.86,14,8.21,15.57h0l.53,2.47h-.62C437.28,143.79,434.06,143.79,434,143.79Zm-1.2-17.33c-.91,0-1.84.79-2.78,2.34,0,0-2.9,6-1,10.19a6.07,6.07,0,0,0,2.19,2.52,7.72,7.72,0,0,0,4.46,1.18c1.2,0,2.95-.09,4.94-.22l-.27-1.25c-.9-3.92-4-14.2-7.33-14.74Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M447.3,174.75l-6.63-32.28h.62a74.75,74.75,0,0,0,10-1.3l.59-.13L455,173.43Zm-5.3-31.3,6.23,30,5.7-1-3-30.16A74.44,74.44,0,0,1,442,143.45Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M451,142.3l-.86-8.92a18,18,0,0,1,.23-5.43c.48-2.33,1.35-3.9,2.58-4.67a3.91,3.91,0,0,1,3.15-.39,6.62,6.62,0,0,1,4.29,3.76c4.29,9.18-1.92,12.95-2.41,13.23a19.67,19.67,0,0,1-6.39,2.3Zm3.91-18.49a2.62,2.62,0,0,0-1.39.38c-1,.61-1.68,2-2.1,4a16.85,16.85,0,0,0-.21,5.11L452,141a17.39,17.39,0,0,0,5.44-2h0c.24-.13,6-3.28,2-11.84a5.59,5.59,0,0,0-3.58-3.17,3.91,3.91,0,0,0-1-.2Z",
    fill: "#fff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "359.29 80.62 361.25 76.15 400.92 96.27 359.29 80.62",
    fill: "#FD9300"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "390.02 40.67 419.92 78.67 394.21 38.15 390.02 40.67",
    fill: "#FD9300"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.9 27.26 450.37 27.26 449.06 71.46 445.9 27.26",
    fill: "#FD9300"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 82.66 502.59 50.6 505.81 53.52 470.69 82.66",
    fill: "#FD9300"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.29 80.62 361.25 76.15 400.92 96.27 359.29 80.62",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.02 40.67 419.92 78.67 394.21 38.15 390.02 40.67",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.9 27.26 450.37 27.26 449.06 71.46 445.9 27.26",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 82.66 502.59 50.6 505.81 53.52 470.69 82.66",
    fill: "#fff"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M690.23,257.16l-9.68,6.52s-6.94-13.88,4-19.76C684.55,243.92,684.13,253.38,690.23,257.16Z",
    fill: "#000000"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M691.66,267.73l-1.43-10.57s7.78-.21,13-12.19l5.47,8.83S704.86,263.73,691.66,267.73Z",
    fill: "#000000"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M629.46,307l4,18.92s46-8.83,67.71-23.55c0,0,22.23-11.32,28.14-21.64a22.28,22.28,0,0,0-1.23-20.2s-6.94-13.25-22.45,5.25l-23.17,23.34Z",
    fill: "#FD9300"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M629.46,307l4,18.92s46-8.83,67.71-23.55c0,0,22.23-11.32,28.14-21.64a22.28,22.28,0,0,0-1.23-20.2s-6.94-13.25-22.45,5.25l-23.17,23.34Z",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M684.55,235.72v9.88s0,8,5.68,11.56c0,0,8.41-.21,13-12.19l-.2-14.09,4-13.18h-5Z",
    fill: "#f9b499"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M684.55,235.72v9.88s7.5-3.53,8.16-11.24Z",
    fill: "#f7a48b"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.44,
    cy: 217.73,
    rx: 21.37,
    ry: 12.63,
    transform: "translate(266.57 803.73) rotate(-71.8)",
    fill: "#f9b499"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M673.61,211.54A26.3,26.3,0,0,0,693,204.6a14.93,14.93,0,0,1,5.51,8.83v5.26l4.59,7.8v4.39s12.19-10.09,7.77-30.91c0,0-4.32-13.24-12.36-5,0,0-2.61-7.84-8-1.27C690.44,193.66,678.87,188.2,673.61,211.54Z",
    fill: "#000000"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 702.05,
    cy: 222.19,
    rx: 3.57,
    ry: 4.49,
    fill: "#f9b499"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M780.73,602.37c-9.56,8-28.05,9.88-28.05,9.88L709,499.1c-8.29-14-8.61-42.38-8.61-42.38L688,388.51l-19.45,81c-4.14,13.38-2.87,33.78-2.87,33.78,3.83,14.66,7.66,60.87,7.66,60.87l5.41,45.26-3.39.64-20.91,4-2.53.48s-7.9-49.73-15.24-78.41c-.14-.57-.29-1.15-.43-1.71-6.93-28.17-7.85-57.25-7.85-57.25-1-51.3,23.52-128.68,23.52-128.68,46.46,8,76.71,4.71,76.71,4.71,5.56,14.29,13.54,126.8,13.54,126.8Z",
    fill: "#000000"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M283.46,312.67c-3,1.39-5,12.44-5,12.44l-25.31-.24c-28.31-1.15-37.75-11.73-37.75-11.73,0,3.92-3.51,15.42-3.51,15.42-12.49,35.89-42.73,16.1-42.73,16.1q.09-5.76.29-11c1.75-47.81,9.07-65.52,9.07-65.52,4.44-15.48,15.79-15.79,15.79-15.79l6.91-2.76,2.91-4.15c3.22-4.9,5.46-4.29,5.46-4.29v1.13a4.46,4.46,0,0,0,1.21,3.06l5.61,6a5.83,5.83,0,0,1,1.56,4v2.48l.58,22.44,15.49,20C254,298.88,283.46,312.67,283.46,312.67Z",
    fill: "#FD9300"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M202.24,253.54s4.89,5.64,15.62,5.53l.64,21.17-11.2-14.5,4.84,4.83-.81-10.7S204.43,258.72,202.24,253.54Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.24,253.54s4.89,5.64,15.62,5.53l.64,21.17-11.2-14.5,4.84,4.83-.81-10.7S204.43,258.72,202.24,253.54Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M215.35,313.14c0,3.92-3.51,15.42-3.51,15.42-12.49,35.89-42.73,16.1-42.73,16.1q.09-5.76.29-11c7.17,3.66,26.74,11.79,34.83-3.07,0,0,6.7-9.78,6.14-19,0,0-19.72-9.59-25.91-19.56l4.09-8.19S203.05,306,215.35,313.14Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.35,313.14c0,3.92-3.51,15.42-3.51,15.42-12.49,35.89-42.73,16.1-42.73,16.1q.09-5.76.29-11c7.17,3.66,26.74,11.79,34.83-3.07,0,0,6.7-9.78,6.14-19,0,0-19.72-9.59-25.91-19.56l4.09-8.19S203.05,306,215.35,313.14Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M213.79,312.15s17.21-8.65,23.92,10.94C237.71,323.09,224.1,321.34,213.79,312.15Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,312.15s17.21-8.65,23.92,10.94C237.71,323.09,224.1,321.34,213.79,312.15Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M294.15,314.32a13.26,13.26,0,0,1,8.17.12,8.4,8.4,0,0,1,2.21,1.46,2.21,2.21,0,0,0,.4.28,1.09,1.09,0,0,1,.37,1.5,1.08,1.08,0,0,1-.71.5,8.9,8.9,0,0,1-4.82-.38A18.89,18.89,0,0,0,294.15,314.32Z",
    fill: "#f7a48b"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M283.46,312.67l10.69,1.65a7.91,7.91,0,0,1,4.49,2.32l9.67,10a2,2,0,0,1,.38,2.4,1.48,1.48,0,0,1-1.4.77s.8,2.92-1.35,2.92c0,0,.92,3.22-3.68,2.6,0,0,0,3.69-5.06.77l-18.79-11S280.12,314.43,283.46,312.67Z",
    fill: "#f9b499"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M302.26,335.3a27.24,27.24,0,0,1-9.33-5.52,24.38,24.38,0,0,1,4.94,2.3A24.78,24.78,0,0,1,302.26,335.3Z",
    fill: "#f7a48b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M305.7,332.54a27.75,27.75,0,0,1-9.33-5.52,24.3,24.3,0,0,1,4.93,2.3A24.85,24.85,0,0,1,305.7,332.54Z",
    fill: "#f7a48b"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M307.83,329.78a27.75,27.75,0,0,1-9.33-5.52,24.14,24.14,0,0,1,4.94,2.3A24.78,24.78,0,0,1,307.83,329.78Z",
    fill: "#f7a48b"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.06,
    cy: 218.21,
    rx: 13.85,
    ry: 17.95,
    transform: "matrix(0.96, -0.27, 0.27, 0.96, -50.22, 67.91)",
    fill: "#f9b499"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5,201.14s3.74,7,17,8.67a23.85,23.85,0,0,1,1.74,17,13.83,13.83,0,0,1-9.82,9v4.64a7.09,7.09,0,0,1,4.23,4.25A62.83,62.83,0,0,1,249,252.94s-6.3-17.31-5.77-33.22a24.52,24.52,0,0,0-6.61-18.56s-8-10-13.84-9.62a18.58,18.58,0,0,1-2.36,0c-4.7-.36-18.52-.87-18.81,5.5,0,0,.91,18.23-11.4,33.53,0,0-28,27.62-29.22,35.09,0,0,6.6,11.51,14,15,0,0,2.15-8.94,3.41-12.53,0,0,3.56-14.6,15.79-15.79l6.91-2.76s5.46-7.91,8.37-8.44V222.9l-1-5.9S221.88,210.29,218.5,201.14Z",
    fill: "#000000"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.46,
    cy: 219.3,
    rx: 3.39,
    ry: 3.53,
    fill: "#f9b499"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M207.1,192.2a9.88,9.88,0,0,0,3.44,1,16,16,0,0,0,3.53,0,28,28,0,0,0,3.53-.61l1.76-.45c.59-.17,1.17-.34,1.79-.47-.52.35-1.06.65-1.6,1a9.29,9.29,0,0,1-1.71.76,15.39,15.39,0,0,1-3.66.88,10.74,10.74,0,0,1-3.79-.23A6.54,6.54,0,0,1,207.1,192.2Z",
    fill: "#FD9300"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M453.92,196.22s-13.58,5.09-17.51-22.13l11.15-1.92,6.7-1.15,10.28-1.77S471.5,195.27,453.92,196.22Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSolution);
export default __webpack_public_path__ + "static/media/Business-solution.e93d8f47b51842a01b442be0c49958f7.svg";
export { ForwardRef as ReactComponent };